import React, { useEffect, useState } from "react";
import { Box, Button } from "@mui/material";
import AppModal from "../../../components/AppModal/AppModal";
import './WorkersAvailability.css'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter } from "@fortawesome/free-solid-svg-icons";
import { DataGrid } from "@mui/x-data-grid";
import { getWorkersAvailability } from "../../../api/apiCall";
import { useAuth } from "../../../auth/auth";
import { format } from "date-fns";
import FilterModal from "./Modal/Modal";

interface Worker {
  id: string | number;
  name: string;
}

const WorkersAvailability = () => {
    const {state} = useAuth();
    const [open, setOpen] = useState(false);
    const [workers, setWorkers] = useState<Worker[]>([]);
    const [selected, setSelected] = useState(0);
    const [date, setDate] = useState<any>([
        {
          startDate: new Date(),
          endDate: new Date(new Date().setDate(new Date().getDate() + 28)),
          key: 'selection'
        }
    ]);

    const getWorkers = async () => {
        const response = await getWorkersAvailability(state.user?.token, {
            startDate: format(date[0].startDate, 'MM-dd-yyyy'),
            endDate: format(date[0].endDate, 'MM-dd-yyyy'),
            type: selected,
        })
       setWorkers(response)
    }

    useEffect(() => {
        getWorkers();
    }, [date, selected])

    const handleClick = (workerId: any) => {
        const url = `/pace-team/resourcing/profile?workerId=${workerId}`;
        window.open(url, '_blank');
    };

    const columns: any = [
        {
            field: "name",
            headerName: "Full Name",
            flex: 1,
            renderCell: (params: any) => (
                <div onClick={() => handleClick(params.row.workerId)}>
                    {params.row.name} {params.row.surname}
                </div>
            ),
        },
        {
          field: "phoneNumber",
          headerName: "Phone Number",
          headerAlign: "center",
          align: "center",
          flex: 1,
        },
        {
          field: "pts",
          headerName: "PTS",
          flex: 1,
          align: "center",
          headerAlign: "center",
        },
        {
          field: "email",
          headerName: "Email",
          headerAlign: "center",
          align: "center",
          flex: 1.5,
        },
        {
          field: "notes",
          headerName: "Notes",
          flex: 1.5,
          align: "center",
          headerAlign: "center",
        },
    ];

    const workersWithKey = workers.map((worker, index) => ({
        ...worker,
        rowKey: `${worker.id}-${index}`,
        workerId: `${worker.id}`
    }))

    return (
        <div className="workers-container">
            <div className="filter-button">
                <Button
                    variant="contained"
                    style={{boxShadow: 'none'}}
                    onClick={() => setOpen(true)}
                >
                    <FontAwesomeIcon icon={faFilter} />&nbsp;&nbsp; Filter
                </Button>
            </div>

            <Box
                sx={{
                    width: "70%",
                    height: "750px",
                    margin: "0 auto",
                    "@media (max-width: 800px)": {
                        overflowX: "auto",
                        margin: 1,
                        minWidth: "95%",
                    },
                }}
            >
                <DataGrid
                    rows={workersWithKey}
                    columns={columns}
                    getRowId={(row: any) => `${row.rowKey}`}
                    disableRowSelectionOnClick
                    sx={{
                        "@media (max-width: 700px)": {
                            minWidth: "100%",
                        },
                        "& .MuiDataGrid-columnHeader": {
                            color: "#333",
                            fontWeight: "bold",
                            fontSize: 15,
                            backgroundColor: "#f0f0f0",
                        },
                        "& .MuiDataGrid-columnHeaderTitle": {
                            fontWeight: "bold",
                        },
                        "& .MuiDataGrid-row:hover": {
                            backgroundColor: "#f1f1f1",
                        },
                    }}
                />
            </Box>
            <AppModal
                open={open}
                onCancel={() => setOpen(false)}
                footer={[]}
            >
                <FilterModal selected={selected} setSelected={setSelected} date={date} setDate={setDate} />
            </AppModal>
        </div>
    )
}

export default WorkersAvailability;
